import getAccessToken from '../auth';

export const successRequestInterceptor = async (config) => {
  const { REACT_APP_API_ENDPOINT } = process.env;

  const baseUrl = REACT_APP_API_ENDPOINT || 'http://localhost:8080';

  console.info('BASE_URL:', baseUrl);

  // Prevent absolute URLs (security / consistency)
  if (config.url.startsWith('http')) {
    throw new Error('Bad request: absolute URLs are not allowed');
  }

  const accessToken = await getAccessToken();

  const updatedHeaders = {
    ...(config.headers || {}),
    ...(accessToken && {
      Authorization: `Bearer ${accessToken}`,
    }),
  };

  return {
    ...config,
    url: `${baseUrl}/${config.url}`,
    headers: updatedHeaders,
  };
};

export const errorRequestInterceptor = (error) => Promise.reject(error);
